import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import { IRosaPatientRecord } from 'gen/ApiClient';
import React from 'react';

interface IProps {
	item: IRosaPatientRecord;
	style?: React.CSSProperties;
}

export const RosaPatientRecordListItemStatusIcon = ({ item, style }: IProps) => {
	if (item.isLinkedToHamsPatient) {
		return <CheckCircleOutlineIcon style={style} />;
	} else {
		return <HighlightOffOutlinedIcon style={style} />;
	}
};
